import React from "react"
import { useTranslation } from "react-i18next"

import TableRowsRoundedIcon from "@mui/icons-material/TableRowsRounded"
import { Stack, Typography } from "@mui/material"
import { GridOverlay } from "@mui/x-data-grid-pro"

export const SiteBillsEmptyOverlay: React.FC = () => {
  const { t } = useTranslation("sites")

  return (
    <GridOverlay>
      <Stack
        sx={{
          alignItems: "center",
          color: "text.disabled",
          gap: 2,
        }}
      >
        <TableRowsRoundedIcon fontSize="large" />
        <Typography
          variant="h3"
          sx={{
            color: "text.disabled",
          }}
        >
          {t("bills.grid.empty")}
        </Typography>
      </Stack>
    </GridOverlay>
  )
}
